import {
  ORDER_SHIPMENTS_INDEX_REQUESTED,
  ORDER_SHIPMENTS_INDEX_SUCCESS,
  ORDER_SHIPMENTS_INDEX_FAILURE,
  ORDER_SHIPMENT_PREPARE_REQUESTED,
  ORDER_SHIPMENT_PREPARE_SUCCESS,
  ORDER_SHIPMENT_PREPARE_FAILURE,
  ORDER_SHIPMENTS_PREPARE_RESET,
  ORDER_SHIPMENTS_PREPARE_ALL_REQUESTED,
  ORDER_SHIPMENTS_PREPARE_ALL_SUCCESS,
  ORDER_SHIPMENTS_PREPARE_ALL_FAILURE,
  ORDER_SHIPMENTS_CONVERT_TO_TOTES_REQUESTED,
  ORDER_SHIPMENTS_CONVERT_TO_TOTES_SUCCESS,
  ORDER_SHIPMENTS_CONVERT_TO_TOTES_FAILURE,
} from '../types';

const INITIAL_STATE = {
  orderShipments: [],
  isFetching: false,
  isFetchingMore: false,
  isPreparing: false,
  isPreparingAll: false,
  isConverting: false,
  lastConvertResult: null,
  lastPage: false,
  continuationToken: null,
  nextPrepareCursor: null,
  prepareLastPage: false,
  lastPrepareResult: null,
  prepareAllSummary: null,
  status: 'waiting',
  errors: null
};

const mergeOrderShipments = (currentShipments, newShipments) => {
  const mergedShipments = new Map();

  [...currentShipments, ...newShipments].forEach((shipment) => {
    mergedShipments.set(shipment.order_shipment_id, shipment);
  });

  return Array.from(mergedShipments.values());
};

const orderShipments = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case ORDER_SHIPMENTS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: !action.append,
        isFetchingMore: action.append,
        status: 'requesting',
        errors: null
      });

    case ORDER_SHIPMENTS_INDEX_SUCCESS: {
      const newShipments = action.payload.prepared_order_shipments || [];

      return Object.assign({}, state, {
        orderShipments: action.append ? mergeOrderShipments(state.orderShipments, newShipments) : newShipments,
        isFetching: false,
        isFetchingMore: false,
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        status: 'success',
        errors: null
      });
    }

    case ORDER_SHIPMENTS_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchingMore: false,
        status: 'error',
        errors: action.error
      });

    case ORDER_SHIPMENT_PREPARE_REQUESTED:
      return Object.assign({}, state, {
        isPreparing: true,
        lastPrepareResult: null,
        status: 'requesting',
        errors: null
      });

    case ORDER_SHIPMENT_PREPARE_SUCCESS:
      return Object.assign({}, state, {
        isPreparing: false,
        nextPrepareCursor: action.payload.next_cursor || null,
        prepareLastPage: action.payload.last_page,
        lastPrepareResult: action.payload,
        status: 'success',
        errors: null
      });

    case ORDER_SHIPMENT_PREPARE_FAILURE:
      return Object.assign({}, state, {
        isPreparing: false,
        status: 'error',
        errors: action.error
      });

    // Restarts the awaiting-fulfillment cursor walk so newly arrived orders
    // get found even after earlier pages were already prepared
    case ORDER_SHIPMENTS_PREPARE_RESET:
      return Object.assign({}, state, {
        nextPrepareCursor: null,
        prepareLastPage: false,
        lastPrepareResult: null,
        prepareAllSummary: null,
        errors: null
      });

    case ORDER_SHIPMENTS_PREPARE_ALL_REQUESTED:
      return Object.assign({}, state, {
        isPreparingAll: true,
        prepareAllSummary: null,
        status: 'requesting',
        errors: null
      });

    case ORDER_SHIPMENTS_PREPARE_ALL_SUCCESS:
      return Object.assign({}, state, {
        isPreparingAll: false,
        prepareAllSummary: action.payload,
        prepareLastPage: true,
        nextPrepareCursor: null,
        status: 'success',
        errors: null
      });

    case ORDER_SHIPMENTS_PREPARE_ALL_FAILURE:
      return Object.assign({}, state, {
        isPreparingAll: false,
        status: 'error',
        errors: action.error
      });

    case ORDER_SHIPMENTS_CONVERT_TO_TOTES_REQUESTED:
      return Object.assign({}, state, {
        isConverting: true,
        lastConvertResult: null,
        status: 'requesting',
        errors: null
      });

    case ORDER_SHIPMENTS_CONVERT_TO_TOTES_SUCCESS:
      return Object.assign({}, state, {
        isConverting: false,
        lastConvertResult: action.payload,
        status: 'success',
        errors: null
      });

    case ORDER_SHIPMENTS_CONVERT_TO_TOTES_FAILURE:
      return Object.assign({}, state, {
        isConverting: false,
        status: 'error',
        errors: action.error
      });

    default:
      return state;
  }
};

export default orderShipments;
